<template>
<nav class="navbar navbar-expand navbar-light topbar static-top  d-flex justify-content-between">
  <div class="logo">
    <a href="/"><img :src="logo" /> <!--<span class="baseline">{{ baseline }}</span>--></a>
  </div>

  <div class="d-flex align-items-center">
  <LanguageSwitch />

  <button id="sidebarToggleTop"
          class="btn btn-link d-md-none rounded-circle mr-3">
    <i class="fa fa-bars"></i>
    <!-- Topbar Navbar
<ul class="navbar-nav ml-auto">

  <li class="nav-item">
    <a class="nav-link"
       href="#">
      {{ $t("header.connection") }}
    </a>
  </li>

  <li class="nav-item">
    <a class="nav-link"
       href="#">Support</a>
  </li>
</ul>-->
    <!-- Sidebar Toggle (Topbar) -->

  </button>
  </div>
  <!--
  <div v-if="steps.length > 1">
    <h2 class="h2 text-gray-900 mb-4">{{ step.name | multitranslate }}</h2>
  </div>-->

</nav>
</template>

<style>
nav {
  height: 75px;
}
nav a:hover, nav a, nav i{
  color: white;
}

.logo a:hover {
  text-decoration: none;
}

.iconic {
  width: 16px;
  height: 16px;
  display: inline-block;
  margin: 0px 6px 0 0;
  vertical-align: middle;
  top: -3px;
  fill: #ffffff;
}
.logo img {
  height: 40px;
  margin-right: 2em;
}

.baseline {
  color: #fff;
  font-size: 22px;
  margin: 0 auto;
  white-space: nowrap;
  text-transform: uppercase;
  font-weight: 800;
}
</style>
<script>
import LanguageSwitch from './LanguageSwitch.vue';
export default {
  components: {
    LanguageSwitch
  },
  props: [
    'logo',
    'baseline'
  ],
  created() {

  },
  data: function() {
    return {
      currentUser: {}
    }
  },
  methods: {},
  mounted() {}
}
</script>
